module.exports = __webpack_public_path__ + "media/images/haircut/main_image1-bc405a071fcec2c88ba3fb507399ccd2.jpg";